function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IplayCircleOutline = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    viewBox: "0 0 110 110",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    opacity: "0.8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0009 91.6605C34.7884 91.6605 18.3342 75.2063 18.3342 54.9938C18.3342 34.7813 34.7884 18.3271 55.0009 18.3271C75.2134 18.3271 91.6675 34.7813 91.6675 54.9938C91.6675 75.2063 75.2134 91.6605 55.0009 91.6605Z",
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "0.8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0009 100.204C30.0698 100.204 9.79053 79.9246 9.79053 54.9936C9.79053 30.0625 30.0698 9.7832 55.0009 9.7832C79.9319 9.7832 100.211 30.0625 100.211 54.9936C100.211 79.9246 79.9319 100.204 55.0009 100.204ZM18.3342 54.9936C18.3342 75.206 34.7884 91.6602 55.0009 91.6602C75.2134 91.6602 91.6675 75.206 91.6675 54.9936C91.6675 34.7811 75.2134 18.3269 55.0009 18.3269C34.7884 18.3269 18.3342 34.7811 18.3342 54.9936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5009 72.8796L70.9051 56.8379C72.1426 55.9212 72.1426 54.0879 70.9051 53.1712L49.5009 37.1296C47.9884 35.9837 45.8342 37.0837 45.8342 38.9629V71.0462C45.8342 72.9254 47.9884 74.0254 49.5009 72.8796Z",
    fill: "white"
  }));
});